import React from 'react';
import './radiobutton.styles.scss';

const RadioButton = ({name,checked,onClick,children}) => (

  <label className="radioContainer">{children}
    <input type="radio" name={name} checked={checked} onClick={onClick}  />
    <span className="checkmarkRadio"></span>
  </label>  

);

export default RadioButton;